/** Theme, workspace name and the default list layout. */
import { useApp } from '../../store/AppContext.jsx';
import Icon from '../../lib/icons.jsx';
import { Section, Row } from './SettingsBits.jsx';

export default function AppearancePane() {
  const { S, setTheme, mode, setMode, patchSettings } = useApp();

  const chooseMode = m => { setMode(m); patchSettings({ startMode: m }); };

  return (
    <>
      <Section title="Theme" hint="Also on the moon button in the top bar.">
        <Row>
          <button type="button" className={`btn${S.theme === 'light' ? ' soft' : ''}`} onClick={() => setTheme('light')}>
            <Icon name="sun" />Light
          </button>
          <button type="button" className={`btn${S.theme === 'dark' ? ' soft' : ''}`} onClick={() => setTheme('dark')}>
            <Icon name="moon" />Dark
          </button>
        </Row>
      </Section>

      <Section title="Workspace name" hint="Shown in the top-right avatar initials.">
        <input
          style={{ maxWidth: 320 }}
          value={S.userName || ''}
          onChange={e => patchSettings({ userName: e.target.value })}
          onBlur={e => patchSettings({ userName: e.target.value.trim() || 'Client Master' })}
        />
      </Section>

      <Section title="Default view" hint="Table rows or client cards.">
        <Row>
          <button type="button" className={`btn${mode === 'list' ? ' soft' : ''}`} onClick={() => chooseMode('list')}>
            <Icon name="list" />Table
          </button>
          <button type="button" className={`btn${mode === 'grid' ? ' soft' : ''}`} onClick={() => chooseMode('grid')}>
            <Icon name="grid" />Cards
          </button>
        </Row>
      </Section>
    </>
  );
}
